import { Extension } from '@tiptap/core';
var TextAlign = Extension.create({
  name: 'textAlign',
  addOptions: function addOptions() {
    return {
      types: [],
      alignments: ['left', 'center', 'right', 'justify'],
      defaultAlignment: 'left'
    };
  },
  addGlobalAttributes: function addGlobalAttributes() {
    var _this = this;

    return [{
      types: this.options.types,
      attributes: {
        textAlign: {
          default: this.options.defaultAlignment,
          parseHTML: function parseHTML(element) {
            return element.style.textAlign || _this.options.defaultAlignment;
          },
          renderHTML: function renderHTML(attributes) {
            if (attributes.textAlign === _this.options.defaultAlignment) {
              return {};
            }

            return {
              style: "text-align: ".concat(attributes.textAlign)
            };
          }
        }
      }
    }];
  },
  addCommands: function addCommands() {
    var _this2 = this;

    return {
      setTextAlign: function setTextAlign(alignment) {
        return function (_ref) {
          var commands = _ref.commands;

          if (!_this2.options.alignments.includes(alignment)) {
            return false;
          }

          return _this2.options.types.every(function (type) {
            return commands.updateAttributes(type, {
              textAlign: alignment
            });
          });
        };
      },
      unsetTextAlign: function unsetTextAlign() {
        return function (_ref2) {
          var commands = _ref2.commands;
          return _this2.options.types.every(function (type) {
            return commands.resetAttributes(type, 'textAlign');
          });
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this3 = this;

    return {
      'Mod-Shift-l': function ModShiftL() {
        return _this3.editor.commands.setTextAlign('left');
      },
      'Mod-Shift-e': function ModShiftE() {
        return _this3.editor.commands.setTextAlign('center');
      },
      'Mod-Shift-r': function ModShiftR() {
        return _this3.editor.commands.setTextAlign('right');
      },
      'Mod-Shift-j': function ModShiftJ() {
        return _this3.editor.commands.setTextAlign('justify');
      }
    };
  }
});
export { TextAlign, TextAlign as default };